/*
 * Ultraest\u00e9tica \u00b7 favoritos, bot\u00f3n \u00abAgregar al carro\u00bb y men\u00fa premium (Nexos, 03-11-2026)
 * Lo sube Nexos al tema (src/ultra-plus.js). Depende de: nx-plus.css y los snippets nx-*.liquid.
 * Los favoritos se guardan en el dispositivo del cliente (localStorage), sin cuenta ni app.
 */
(function () {
  'use strict';
  if (window.__nxPlus) return;
  window.__nxPlus = true;

  var CFG = window.nxPlusCfg || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'nx_favoritos_v1';
  var WA = CFG.wa || '56958639259';
  var CARRO = CFG.carro || ROOT + 'cart';
  var FAVS = CFG.fav || ROOT + 'pages/favoritos';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.65-7 10-7 10z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 8h14l-1.2 11.5a1 1 0 0 1-1 .9H7.2a1 1 0 0 1-1-.9z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function leer() {
    try { var x = JSON.parse(window.localStorage.getItem(KEY) || '[]'); return Array.isArray(x) ? x : []; } catch (e) { return []; }
  }
  function guardar(l) {
    try { window.localStorage.setItem(KEY, JSON.stringify(l.slice(0, 60))); } catch (e) {}
  }
  function plata(c) {
    var n = Math.round((Number(c) || 0) / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function todos(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function texto(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function attr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }

  // ---------- favoritos ----------
  function pintar() {
    var l = leer();
    var n = l.length;
    var hs = {};
    l.forEach(function (f) { hs[f.h] = 1; });
    todos('[data-nx-fav-count]').forEach(function (el) {
      texto(el, n > 99 ? '99+' : String(n));
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
    todos('[data-nx-fav-link]').forEach(function (a) {
      attr(a, 'aria-label', n ? 'Mis favoritos, ' + n + (n === 1 ? ' producto' : ' productos') : 'Mis favoritos');
      a.classList.toggle('is-on', n > 0);
    });
    todos('[data-nx-fav]').forEach(function (b) {
      var on = !!hs[b.getAttribute('data-handle')];
      b.classList.toggle('is-on', on);
      attr(b, 'aria-pressed', on ? 'true' : 'false');
      attr(b, 'aria-label', on ? 'Quitar de favoritos' : 'Agregar a favoritos');
      texto(b.querySelector('[data-nx-fav-txt]'), on ? 'En tus favoritos' : 'Guardar en favoritos');
    });
  }

  var tAviso = null;
  function aviso(msg, conEnlace) {
    var el = document.querySelector('.nx-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nx-aviso';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span>' + esc(msg) + '</span>' + (conEnlace ? '<a href="' + esc(FAVS) + '">Ver favoritos</a>' : '');
    el.classList.add('is-on');
    clearTimeout(tAviso);
    tAviso = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  function alternar(b) {
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var l = leer();
    var i = -1;
    l.forEach(function (f, k) { if (f.h === h) i = k; });
    if (i >= 0) {
      l.splice(i, 1);
      aviso('Quitado de tus favoritos', false);
    } else {
      var precio = Number(b.getAttribute('data-price')) || 0;
      l.unshift({ h: h, id: b.getAttribute('data-id') || '', t: b.getAttribute('data-title') || '', i: b.getAttribute('data-img') || '', p: precio, d: Date.now() });
      aviso('Guardado en tus favoritos', !document.querySelector('[data-nx-fav-page]'));
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToWishlist', { content_ids: [String(b.getAttribute('data-id') || h)], content_type: 'product', content_name: b.getAttribute('data-title') || h, value: precio / 100, currency: 'CLP' });
        }
      } catch (e) {}
    }
    guardar(l);
    pintar();
    if (i >= 0 && document.querySelector('[data-nx-fav-page]')) paginaFavoritos();
  }

  // Coraz\u00f3n en la ficha del producto (debajo del t\u00edtulo)
  function corazonFicha() {
    var p = window.nxProducto;
    if (!p || document.querySelector('[data-nx-fav-pdp]')) return;
    var t = document.querySelector('main .product__title') || document.querySelector('.product__title');
    if (!t) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nx-fav-pdp';
    b.setAttribute('data-nx-fav', '');
    b.setAttribute('data-nx-fav-pdp', '');
    b.setAttribute('data-handle', p.h || '');
    b.setAttribute('data-id', String(p.id || ''));
    b.setAttribute('data-title', p.t || '');
    b.setAttribute('data-img', p.i || '');
    b.setAttribute('data-price', String(p.p || 0));
    b.innerHTML = HEART + '<span data-nx-fav-txt>Guardar en favoritos</span>';
    t.insertAdjacentElement('afterend', b);
  }

  // ---------- carro ----------
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error((d && (d.description || d.message)) || 'No se pudo agregar');
        return d;
      });
    });
  }
  function contarCarro() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        todos('.cart__toggle').forEach(function (a) { a.classList.toggle('cart__toggle--has-items', c.item_count > 0); });
        todos('[data-cart-count]').forEach(function (el) { texto(el, String(c.item_count)); });
        try { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); } catch (e) {}
        return c;
      });
  }
  function textoBtn(btn, t) { texto(btn.querySelector('[data-nx-txt]'), t); }
  function agregar(btn) {
    if (btn.getAttribute('data-state') === 'ok') { window.location.href = CARRO; return; }
    if (btn.getAttribute('aria-busy') === 'true') return;
    var ids = String(btn.getAttribute('data-variant') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var normal = btn.getAttribute('data-txt') || 'Agregar al carro';
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    textoBtn(btn, 'Agregando\u2026');
    postJSON(ROOT + 'cart/add.js', { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      .then(contarCarro)
      .then(function () {
        btn.setAttribute('data-state', 'ok');
        btn.classList.add('is-ok');
        textoBtn(btn, btn.getAttribute('data-ok') || 'Agregado \u00b7 Ver carro');
      })
      .catch(function (e) {
        btn.classList.add('is-error');
        textoBtn(btn, /stock|disponible|available|sold|agotad/i.test(String(e && e.message)) ? 'Sin stock suficiente' : 'No se pudo agregar');
        setTimeout(function () { btn.classList.remove('is-error'); textoBtn(btn, normal); }, 2600);
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      });
  }

  // ---------- men\u00fa premium ----------
  function subirScroll(el) {
    while (el) { if (el.scrollTop) el.scrollTop = 0; el = el.parentElement; }
  }
  function menuSub(btn) {
    var menu = btn.closest('[data-nx-menu]');
    if (!menu) return;
    var id = btn.getAttribute('data-nx-sub');
    var hay = false;
    todos('[data-nx-menu] [data-nx-sub-panel]').forEach(function (p) {
      if (!menu.contains(p)) return;
      var es = p.getAttribute('data-nx-sub-panel') === id;
      p.hidden = !es;
      if (es) hay = true;
    });
    if (!hay) return;
    var main = menu.querySelector('[data-nx-menu-principal]');
    if (main) main.hidden = true;
    menu.classList.add('is-sub');
    menu.setAttribute('data-nx-abierto', id);
    subirScroll(menu);
    var v = menu.querySelector('[data-nx-sub-panel="' + id + '"] [data-nx-sub-volver]');
    if (v) { try { v.focus({ preventScroll: true }); } catch (e) { v.focus(); } }
  }
  function menuVolver(btn) {
    var menu = btn.closest('[data-nx-menu]');
    if (!menu) return;
    Array.prototype.slice.call(menu.querySelectorAll('[data-nx-sub-panel]')).forEach(function (p) { p.hidden = true; });
    var main = menu.querySelector('[data-nx-menu-principal]');
    if (main) main.hidden = false;
    menu.classList.remove('is-sub');
    var id = menu.getAttribute('data-nx-abierto');
    var tile = id && menu.querySelector('[data-nx-sub="' + id + '"]');
    if (tile) { try { tile.focus({ preventScroll: true }); } catch (e) { tile.focus(); } }
  }

  // ---------- p\u00e1gina \u00abMis favoritos\u00bb ----------
  function imgTam(u, w) {
    if (!u) return '';
    u = String(u);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function tarjeta(f, p) {
    var t = p ? p.title : f.t;
    var url = p ? p.url : ROOT + 'products/' + f.h;
    var img = p && p.featured_image ? imgTam(p.featured_image, 300) : f.i;
    var precio = p ? p.price : f.p;
    var antes = p && p.compare_at_price > p.price ? p.compare_at_price : 0;
    var boton;
    if (p && !p.available) {
      boton = '<a class="nx-carro nx-carro--agotado" href="https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, quiero consultar por ' + t + ' (agotado en la web)') + '" target="_blank" rel="noopener"><span data-nx-txt>Agotado \u00b7 Consultar</span></a>';
    } else if (p && p.variants && p.variants.length > 1) {
      boton = '<a class="nx-carro nx-carro--opcion" href="' + esc(url) + '"><span data-nx-txt>Elegir opci\u00f3n</span></a>';
    } else if (p && p.variants && p.variants.length) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      boton = '<button type="button" class="nx-carro" data-nx-add data-variant="' + esc(v.id) + '" data-txt="Agregar al carro">' + BAG + '<span data-nx-txt>Agregar al carro</span></button>';
    } else {
      boton = '<a class="nx-carro nx-carro--opcion" href="' + esc(url) + '"><span data-nx-txt>Ver producto</span></a>';
    }
    return '<li class="nx-favs__item">' +
      '<a class="nx-favs__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</a>' +
      '<div class="nx-favs__info">' +
        '<div class="nx-favs__fila"><a class="nx-favs__titulo" href="' + esc(url) + '">' + esc(t) + '</a>' +
        '<button type="button" class="nx-fav nx-fav--lista is-on" data-nx-fav data-handle="' + esc(f.h) + '" aria-pressed="true" aria-label="Quitar de favoritos">' + HEART + '</button></div>' +
        '<div class="nx-favs__precio">' + (precio ? '<strong>' + plata(precio) + '</strong>' : '') + (antes ? '<s>' + plata(antes) + '</s>' : '') + '</div>' +
        boton +
      '</div></li>';
  }
  var versionPagina = 0;
  function paginaFavoritos() {
    var cont = document.querySelector('[data-nx-fav-page]');
    if (!cont) return;
    var mia = ++versionPagina;
    var lista = cont.querySelector('[data-nx-fav-lista]');
    var vacio = cont.querySelector('[data-nx-fav-vacio]');
    var acciones = cont.querySelector('[data-nx-fav-acciones]');
    var cuenta = cont.querySelector('[data-nx-fav-cuenta]');
    var wa = cont.querySelector('[data-nx-fav-wa]');
    var todosBtn = cont.querySelector('[data-nx-fav-todos]');
    var l = leer();
    texto(cuenta, l.length ? l.length + (l.length === 1 ? ' producto guardado' : ' productos guardados') + ' en este dispositivo.' : '');
    vacio.hidden = l.length > 0;
    acciones.hidden = l.length === 0;
    lista.innerHTML = l.map(function (f) { return tarjeta(f, null); }).join('');
    if (todosBtn) todosBtn.hidden = true;
    pintar();
    if (!l.length) return;
    Promise.all(l.map(function (f) {
      return fetch(ROOT + 'products/' + encodeURIComponent(f.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      if (mia !== versionPagina) return;
      var datos = l.map(function (f, k) { return { f: f, p: ps[k] }; });
      lista.innerHTML = datos.map(function (x) { return tarjeta(x.f, x.p); }).join('');
      var lineas = datos.map(function (x) {
        var t = x.p ? x.p.title : x.f.t;
        var pr = x.p ? x.p.price : x.f.p;
        var u = window.location.origin + (x.p ? x.p.url : ROOT + 'products/' + x.f.h);
        return '\u2022 ' + t + (pr ? ' (' + plata(pr) + ')' : '') + '\n  ' + u;
      });
      if (wa) wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, quiero cotizar mi lista de favoritos de Ultraest\u00e9tica:\n\n' + lineas.join('\n') + '\n\n\u00bfMe ayudan?');
      var ids = datos.filter(function (x) { return x.p && x.p.available && x.p.variants && x.p.variants.length === 1; }).map(function (x) { return x.p.variants[0].id; });
      if (todosBtn) {
        todosBtn.setAttribute('data-variant', ids.join(','));
        todosBtn.hidden = ids.length < 2;
      }
      pintar();
    });
  }

  // ---------- eventos ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-nx-fav]');
    if (b) { e.preventDefault(); e.stopPropagation(); alternar(b); return; }
    var c = t.closest('[data-nx-add]');
    if (c) { e.preventDefault(); e.stopPropagation(); agregar(c); return; }
    var s = t.closest('[data-nx-sub]');
    if (s) { e.preventDefault(); menuSub(s); return; }
    var v = t.closest('[data-nx-sub-volver]');
    if (v) { e.preventDefault(); menuVolver(v); }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) pintar(); });

  // Bloque \u00abCompra con confianza\u00bb bajo los filtros del costado (solo computador; el CSS lo oculta en el celular)
  function confianza() {
    var lista = document.querySelector('.collection__filters-list');
    if (!lista || lista.querySelector('.nx-confianza')) return;
    var ic = function (d) { return '<span class="nx-confianza__ic"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + d + '</svg></span>'; };
    var st = ' fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
    var el = document.createElement('div');
    el.className = 'nx-confianza';
    el.innerHTML = '<p class="nx-confianza__titulo">Compra con confianza</p><ul>' +
      '<li>' + ic('<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"' + st + '/><path d="M9 12l2 2 4-4"' + st + '/>') + '<span><strong>Garant\u00eda de 6 meses</strong>En equipos, con servicio t\u00e9cnico especializado</span></li>' +
      '<li>' + ic('<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"' + st + '/><circle cx="7" cy="17.5" r="1.6"' + st + '/><circle cx="17" cy="17.5" r="1.6"' + st + '/>') + '<span><strong>Env\u00edo gratis en RM</strong>En aparatolog\u00eda sobre $59.990</span></li>' +
      '<li>' + ic('<rect x="3" y="6" width="18" height="12" rx="2"' + st + '/><path d="M3 10h18"' + st + '/>') + '<span><strong>3 cuotas sin inter\u00e9s</strong>Con tarjetas Banco de Chile</span></li>' +
      '<li>' + ic('<path d="M4 6h16v10H8l-4 4z"' + st + '/>') + '<span><strong>Asesor\u00eda experta</strong>Te ayudamos a elegir el equipo para tu centro</span></li>' +
      '</ul><a class="nx-confianza__wa" href="https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, necesito ayuda para elegir un equipo') + '" target="_blank" rel="noopener">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 19.5l1.2-3.6A8 8 0 1 1 8.4 18.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Hablar con una asesora</a>';
    lista.appendChild(el);
  }

  // Banner \u00abTodo para tu BOX\u00bb (el de fondo de tela blanca): versi\u00f3n premium con beneficios, bot\u00f3n a WhatsApp y los 3 productos
  // m\u00e1s vendidos de la colecci\u00f3n
  function promo() {
    Array.prototype.slice.call(document.querySelectorAll('.collection-promo')).forEach(function (p) {
      if (p.classList.contains('nx-promo') || !p.querySelector('img[src*="fondo-de-textura-de-tela-blanca"]')) return;
      var body = p.querySelector('.collection-promo__body');
      var inner = p.querySelector('.collection-promo__inner');
      if (!body || !inner) return;
      p.classList.add('nx-promo');
      var ch = document.createElement('div');
      ch.className = 'nx-promo__chips';
      ch.innerHTML = '<span>Garant\u00eda 6 meses</span><span>Despacho a todo Chile</span><span>3 cuotas sin inter\u00e9s</span>';
      body.appendChild(ch);
      var a = document.createElement('a');
      a.className = 'nx-promo__cta';
      a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, quiero armar mi box y necesito asesor\u00eda');
      a.target = '_blank';
      a.rel = 'noopener';
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 19.5l1.2-3.6A8 8 0 1 1 8.4 18.5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Arma tu box con una asesora';
      body.appendChild(a);
      var vistas = {};
      var imgs = Array.prototype.slice.call(document.querySelectorAll('.product-grid-item')).map(function (c) {
        if (c.classList.contains('soldout')) return null;
        var i = c.querySelector('[data-product-media-featured] img');
        return i ? (i.currentSrc || i.src) : null;
      }).filter(function (s) { if (!s || vistas[s]) return false; vistas[s] = 1; return true; }).slice(0, 3);
      if (imgs.length === 3) {
        var f = document.createElement('div');
        f.className = 'nx-promo__fotos';
        f.setAttribute('aria-hidden', 'true');
        f.innerHTML = imgs.map(function (s) { return '<span><img src="' + esc(s) + '" alt="" loading="lazy"></span>'; }).join('');
        inner.appendChild(f);
      }
    });
  }

  // Flechas para avanzar en el carrusel de categor\u00edas (computador y celular; en el celular adem\u00e1s se desliza con el dedo)
  function flechas() {
    Array.prototype.slice.call(document.querySelectorAll('.nx-cats__fila')).forEach(function (fila) {
      if (fila.getAttribute('data-nx-flechas')) return;
      fila.setAttribute('data-nx-flechas', '1');
      var marco = document.createElement('div');
      marco.className = 'nx-cats__marco';
      fila.parentNode.insertBefore(marco, fila);
      marco.appendChild(fila);
      var svg = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
      var izq = document.createElement('button');
      izq.type = 'button';
      izq.className = 'nx-cats__flecha nx-cats__flecha--izq';
      izq.setAttribute('aria-label', 'Ver categor\u00edas anteriores');
      izq.innerHTML = svg('M15 6l-6 6 6 6');
      var der = document.createElement('button');
      der.type = 'button';
      der.className = 'nx-cats__flecha nx-cats__flecha--der';
      der.setAttribute('aria-label', 'Ver m\u00e1s categor\u00edas');
      der.innerHTML = svg('M9 6l6 6-6 6');
      marco.appendChild(izq);
      marco.appendChild(der);
      var paso = function () { return Math.max(160, Math.round(fila.clientWidth * 0.8)); };
      izq.addEventListener('click', function () { fila.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      der.addEventListener('click', function () { fila.scrollBy({ left: paso(), behavior: 'smooth' }); });
      var revisar = function () {
        var max = fila.scrollWidth - fila.clientWidth;
        var alInicio = fila.scrollLeft <= 4;
        var alFinal = fila.scrollLeft >= max - 4;
        izq.hidden = max <= 4 || alInicio;
        der.hidden = max <= 4 || alFinal;
        marco.classList.toggle('hay-mas', max > 4 && !alFinal);
      };
      fila.addEventListener('scroll', revisar, { passive: true });
      window.addEventListener('resize', revisar);
      revisar();
      setTimeout(revisar, 600);
    });
  }

  function init() {
    flechas();
    promo();
    confianza();
    corazonFicha();
    paginaFavoritos();
    pintar();
    // Tarjetas que llegan despu\u00e9s (filtros, "cargar m\u00e1s", carruseles): se pintan sus corazones
    var pend = null;
    try {
      new MutationObserver(function () {
        if (pend) return;
        pend = setTimeout(function () { pend = null; corazonFicha(); pintar(); }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
